import DnDUploader, {
  DisplayAsset,
  StaticAssetPreview,
} from '@1stLog-engineering/file-uploads'
import { Box, Stack } from '@mantine/core'
import { concat, size } from 'lodash'
import React, { ReactElement } from 'react'

import {
  FeedbackBadge,
  Label,
} from '../../../../../../1stlog-ui/src/components/Field'
import useFieldRaw from '../../../../../../1stlog-ui/src/components/Field/useFieldRaw'

type AdditionalCustomsDocsProps = {}

export const AdditionalCustomsDocs = (
  props: AdditionalCustomsDocsProps,
): ReactElement => {
  const {} = props

  const {
    input: { value: additionalCustomsDocs, onChange: setAdditionalCustomsDocs },
    meta,
  } = useFieldRaw<DisplayAsset[]>('additionalCustomsDocs', {
    ignorePrefix: true,
    subscribeAll: true,
  })

  const onAssetsAdded = (assets: DisplayAsset[]): void => {
    setAdditionalCustomsDocs(
      concat(additionalCustomsDocs, assets).filter(Boolean),
    )
  }

  const onAssetDelete = (index: number): void => {
    const newAssets = additionalCustomsDocs.filter((_, i) => i !== index)
    setAdditionalCustomsDocs(newAssets)
  }

  return (
    <>
      <Box>
        <Label>
          {`${i18n.t(
            'additional_customs_docs',
            'Zusätzliche Zolldokumente',
          )} (optional)`}
        </Label>
        <Stack>
          <Box>
            <DnDUploader
              acceptedMimeTypes={[
                'image/png',
                'image/jpeg',
                'image/jpeg',
                'image/gif',
                'application/pdf',
              ]}
              allowedFileSize={52428800 / 5}
              maxFiles={10}
              currentFileCount={size(additionalCustomsDocs)}
              onAssetAdded={onAssetsAdded}
            />
          </Box>
          <Box>
            <StaticAssetPreview
              assets={additionalCustomsDocs}
              maxWidth="100%"
              height="200px"
              onDelete={(index) => onAssetDelete(index)}
            />
            <FeedbackBadge meta={meta} />
          </Box>
        </Stack>
      </Box>
    </>
  )
}
